import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const IssueRefText = styled.span`
  font-size: ${tokens.font.body};
  font-weight: 700;
  color: ${tokens.text.primary};
  font-variant-numeric: tabular-nums;
`

export const IssueValueText = styled.span<{ $negative?: boolean }>`
  font-size: ${tokens.font.body};
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: ${({ $negative }) => ($negative ? tokens.status.danger.fg : tokens.text.secondary)};
`

export const IssueReasonCell = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.25rem;
  min-width: 14rem;
`

export const IssueReasonNote = styled.span`
  font-size: ${tokens.font.label};
  color: ${tokens.text.muted};
`
